export const LADE_AUSWAHLWERTE_MAIL = "ladeAuswahlwerteMail";